import { I18nData } from './../../api/plyca-dtos';
import { TaskHandler } from '../TaskHandler';

import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { CommunicationEditionComponent } from '../../dossiers/communications/communication.edition.component';
import { CommunicationDTO } from '../../api/plyca-dtos-v2';
import { Configuration } from '../../conf/app.constants';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';


@Component({
  selector: 'messageTask',
  templateUrl: 'messageTask.template.html',
  providers: [DialogService]
})
export class messageTaskComponent extends TaskHandler implements AfterViewInit, OnDestroy {

  notificacionid: string;
  configuration: Configuration;
  @ViewChild('messageContainer') messageContainer: ElementRef;
  constructor(
    private headerActionsService: HeaderActionsService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    let strMsg = '*** Texto Mensaje no definido **';
    if (this.task.work) {
      strMsg = this.task.work.message;
      if (this.task.work.notificacionid) {
        this.notificacionid = this.task.work.notificacionid;
      }

    }

    this.messageContainer.nativeElement.innerHTML = strMsg;
    this.headerActionsService.clearActions();
    this.subscribe(this.headerActionsService.addAction(
      'General.accept',
      'fas fa-lg fa-check',
      'btn-primary',
      true
    ),
      success => {
        this.processTask();
      });
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.cancel',
      'fas fa-times',
      'btn-outline-secondary',
      true
    ), success => {
      this.salir();
    });
    this.waitService.cancelWaiting();
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.modalWindowHash);
    super.ngOnDestroy();
  }

  optionsAvailable(): boolean {
    return (
      this.taskLoaded() &&
      this.task.work != null &&
      this.task.work.options != null
    );
  }

  public selectOp(key) {
    event.preventDefault();
    this.task.work.selectedOption = key;
  }

  public viewCommunicationDetail(): void {



    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      styleClass: 'searchStyle'
    };
    let communicationToEdit = new CommunicationDTO();
    communicationToEdit.identifier = Number(this.notificacionid);

    config.data = {
      'edition': false,
      'isModalWindow': true,
      'communication': communicationToEdit
    }



    let ref = this.dialogService.open(CommunicationEditionComponent, config);

  }

  viewDocument() {
    // this.router.navigate(['documentViewer', document.identifier]);
    let config: DynamicDialogConfig = {
      width: '97%',
      styleClass: 'searchStyle'
    };
    config.data = {
      'id': this.task.work.uuidDoc
    }
    this.waitService.startWaiting();
    let modal = this.dialogService.open(documentViewerComponent, config);
  }
  showInfo(info: string) {
    this.uiService.showMessage(
      info,
      new I18nData('General.info'),
      'helpStyle'
    );
  }
}
